import React from 'react';

const Contact = () => {
    return (
            <div className="text-center" style={{marginBottom: '300px'}} id="contact">
            <p className="text-color">Contact</p>
            <h1 className="text-color mb-5"><b>Let us repair your <br/> electronics, professionally</b></h1>
            <div className="container">
            <div className="d-flex justify-content-center">
                <input type="text" className="form-control col-md-6 me-3" placeholder="First Name" style={{width: '400px', border: 'none', background: 'whitesmoke'}}/>
                <input type="text" className="form-control col-md-6" placeholder="Last Name" style={{width: '400px', border: 'none', background: 'whitesmoke'}}/>
            </div>
            <div className="d-flex justify-content-center mt-4">
                <input type="email" className="form-control col-md-6 me-3" placeholder="Email" style={{width: '400px', border: 'none', background: 'whitesmoke'}}/>
                <input type="text" className="form-control col-md-6" placeholder="Phone Number" style={{width: '400px', border: 'none', background: 'whitesmoke'}}/>
            </div>
            <textarea className="form-control mt-4 mb-4"  rows="4" placeholder="Your Message" style={{width: '820px', border: 'none', background: 'whitesmoke', display: 'block', marginRight: 'auto', marginLeft: 'auto'}}></textarea>
            <button className="btn-style">Send Message</button>
            </div>
        </div>
    );
};

export default Contact;